"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var utils_1 = require("../utils");
var BaseNotificationsStore = /** @class */ (function () {
    function BaseNotificationsStore() {
        var _this = this;
        this.pushNotification = function (notification) {
            var n = tslib_1.__assign({ id: utils_1.guid() }, notification);
            _this.notifications = [n].concat(mobx_1.toJS(_this.notifications));
            return n;
        };
        this.pushSuccessNotification = function (notification) {
            return _this.pushNotification(tslib_1.__assign({}, notification, { warning: false, success: true, error: false }));
        };
        this.pushErrorNotification = function (notification) {
            return _this.pushNotification(tslib_1.__assign({}, notification, { warning: false, success: false, error: true }));
        };
        this.pushWarningNotification = function (notification) {
            return _this.pushNotification(tslib_1.__assign({}, notification, { warning: true, success: false, error: false }));
        };
        this.removeNotification = function (notification) {
            _this.notifications = _this.notifications.filter(function (n) { return n.id !== notification.id; });
        };
        this.removeAllNotifications = function () {
            _this.notifications = [];
        };
        this.notifications = [];
    }
    tslib_1.__decorate([
        mobx_1.observable
    ], BaseNotificationsStore.prototype, "notifications", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseNotificationsStore.prototype, "pushNotification", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseNotificationsStore.prototype, "pushSuccessNotification", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseNotificationsStore.prototype, "pushErrorNotification", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseNotificationsStore.prototype, "pushWarningNotification", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseNotificationsStore.prototype, "removeNotification", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], BaseNotificationsStore.prototype, "removeAllNotifications", void 0);
    return BaseNotificationsStore;
}());
exports.default = BaseNotificationsStore;
